/* eslint-disable */
import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import qs from 'qs';
import { Button, Divider, Typography, Breadcrumb, List, message } from 'antd';
import { SafetyOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { withQuery } from '@/utils';
import * as actions from '@/models/configure/actions';
import * as selectors from '@/models/configure/selectors';
import { getTenantById } from '@/models/tenants/services';
import styles from './configure.module.scss';
import ConfigureDialog from '@/components/dialogs/ConfigureDialog';
import { getCurrentUser } from '@/models/user/selectors';
import * as apis from '@/apis'
const APP_MODE = process.env.APP_MODE === 'tenant' ? "staff" : "manager"

function Products(props) {
  const dispatch = useDispatch();
  const { query, history, match, location } = props;
  const tenantId = props.tenantId || match.params.id;
  const [tenant, setTenant] = useState(null);
  const [Category, setCategory] = useState([]);
  const prevQuery = usePrevious(query);
  const address = useSelector(selectors.addressSelectors);
  const demand = useSelector(selectors.demandSelectors);
  const user = useSelector(getCurrentUser);
  const id = user.getIn([APP_MODE, "_id"])
  const firstInit = useRef(true);

  const saveStaffs = (index) => {
    let isaddress = false
    let isfault = false
    address.toJS().forEach(ele => {
      if (!isaddress) {
        isaddress = ele.is_fault
      }
    })
    // if (!(address.size > 0)) {
    //   message.warning('请添加反件地址')
    //   return false
    // }
    demand.toJS().forEach(ele => {
      if (!isfault) {
        isfault = ele.is_fault
      }
    })
    // if (!(demand.size > 0)) {
    //   message.warning('请添加完单图片反馈要求')
    //   return false
    // }
    // if (!isaddress || !isfault) {
    //   message.warning('请设置默认选项')
    //   return false
    // }
    apis.saveStaffs(id, {
      address: [...address],
      demand: [...demand],
    }).then(result => {
      message.success('保存成功')
      firstInit.current = true;
    }).catch(err => {
      message.error(err.message || '发生错误')
    })
  }
  const fetchCategory = useCallback((id) => {
    dispatch(actions.fetchList(id));
  },
    []);
  useEffect(() => {
    if (!firstInit.current) {
      saveStaffs();
    }
  }, [firstInit.current === false && address, firstInit.current === false && demand])
  const showInfoDialog = useCallback(
    (title, type, valuesType, data) => () => {
      dispatch(
        actions.showInfoDialog({
          title,
          type,
          valuesType: valuesType,
          submitCallback: (row) => {
            createdData(row, data)
            window.parent.postMessage({
              dataType: `add${valuesType}Success`,
              selectData: row.data
            })
          }
        })
      );
    },
    []);
  const modInfoDialog = useCallback(
    (title, type, valuesType, rows) => () => {
      dispatch(
        actions.showInfoDialog({
          title,
          type,
          row: rows,
          valuesType: valuesType,
          submitCallback: (row) => {
            upDate(row, rows)
            window.parent.postMessage({
              dataType: `add${valuesType}Success`,
              selectData: row.data
            })
          }
        })
      );
    },
    []
  );
  const setDefault = (valuesType, rows) => () => {
    dispatch(actions.setdefault(valuesType, rows));
    firstInit.current = false;
  }
  const delDefault = (valuesType, rows) => () => {
    dispatch(actions.deldefault(valuesType, rows));
    firstInit.current = false;
  };
  const upDate = (row, rows) => {
    firstInit.current = false;
    dispatch(actions.updated(row.type, row.valuesType, row.data, rows, row.paytype));
  }
  const createdData = (row, data) => {
    let isAdd = true
    data.toJS().forEach(element => {
      if (element[row.valuesType] === row.data && isAdd) {
        message.success('已重复')
        isAdd = false
      }
    });
    firstInit.current = false;
    isAdd ? dispatch(actions.created(row.type, row.valuesType, row.data, row.paytype)) : ""
  }

  useEffect(() => {
    if (id) { fetchCategory(id) }
  }, [id])

  useEffect(() => {
    if (/^\/enterprises\//.test(location.pathname)) {
      getTenantById(tenantId).then((result) => setTenant(result));
    }
  }, [tenantId]);

  useUpdateEffect(() => {
    if (prevQuery.offset !== query.offset) {
      window.scrollTop = 0;
      fetch(query);
    }
  });

  const demandHeader = () => {
    return <div className={styles.configure}>
      <div>完单图片反馈要求</div>
      <Button onClick={showInfoDialog('添加完单图片反馈要求', "add", "demand", demand)}>添加完单图片反馈要求</Button>
    </div>
  }
  const addressHeader = () => {
    return <div className={styles.configure}>
      <div>返件地址</div>
      <Button onClick={showInfoDialog('添加反件地址', "add", "address", address)}>添加返件地址</Button>
    </div>
  }
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          {tenant && (
            <Breadcrumb.Item>
              {tenant.short_name || tenant.name}
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item>工单配置</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <blockquote className={styles.blockquote}>
        <h2 style={{ color: "red" }}>
          注：此处不填写要求则默认工单完结无需师傅拍摄图片或配件无需返厂！
        </h2>
      </blockquote>
      <List
        style={{ backgroundColor: "#ffffff" }}
        header={addressHeader()}
        bordered
        dataSource={address.toJS()}
        renderItem={item => (
          <List.Item key={item.address}>
            <div className={styles.configure}>
              <div>
                {item.is_fault ? <CheckCircleOutlined style={{ color: "#87d068", fontSize: 18 }} /> : ""}
                <span>{item.address}</span>
              </div>
              <div>
                {!item.is_fault ? <a onClick={setDefault("address", item)}>设为默认</a> : ""}
                {(<><Divider type="vertical" />
                  <a onClick={modInfoDialog('修改返件地址', "mod", "address", item)}>修改</a>
                  <Divider type="vertical" />
                  <a onClick={delDefault("address", item)}>删除</a></>)}
              </div>
            </div>
          </List.Item>
        )}
      />
      <br />
      <List
        style={{ backgroundColor: "#ffffff" }}
        header={demandHeader()}
        bordered
        dataSource={demand.toJS()}
        renderItem={item => (
          <List.Item key={item.demand}>
            <div className={styles.configure}>
              <div>
                {item.is_fault ? <CheckCircleOutlined style={{ color: "#87d068", fontSize: 18 }} /> : ""}
                <span> {item.demand}</span>
              </div>
              <div>
                {!item.is_fault ? <a onClick={setDefault("demand", item)}>设为默认</a> : ""}
                {(<><Divider type="vertical" />
                  <a onClick={modInfoDialog('修改完单图片反馈要求', "mod", "demand", item)}>修改</a>
                  <Divider type="vertical" />
                  <a onClick={delDefault("demand", item)}>删除</a></>)}
              </div>
            </div>
          </List.Item>
        )}
      />
      <ConfigureDialog />
    </div>
  );
}

export default withQuery(Products);
